export const showLabels = () => {
    const cardsMore = document.querySelectorAll(".card__more");
    cardsMore.forEach((btn) => {
        const labels = btn.parentElement.querySelectorAll(
            ".card__label.hidden"
        );
        const locationsList = document.querySelectorAll('[data-target="location_select"]')

        btn.addEventListener("click", () => {
            labels.forEach((label) => label.classList.remove("hidden"));

            if (btn.getAttribute('data-watch_location') === 'true')
                locationsList.forEach((location) => location.style.display = 'block');


            btn.remove();
        });


    });
};
